import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { WorkloadManagedTeamEntity } from '../../../domain/entities/workload-managed-team.entity';
import { TeamWorkloadRepository } from '../../../infrastructure/repositories/team-workload.repository';

@Injectable({ providedIn: 'root' })
export class GetMyManagedTeamsUseCase {
  private readonly _repository = inject(TeamWorkloadRepository);

  public execute(): Observable<WorkloadManagedTeamEntity[]> {
    return this._repository.getMyManagedTeams();
  }
}
